// @flow
import React, { Component } from "react";
import withStyles from "elevate-ui/withStyles";
import { withGlobalContext } from "../../../common/GlobalContext";
import enhanceWithClickOutside from "react-click-outside";
import Color from "color";
import classNames from "classnames";

import type { $Site } from "flow/types";

import RenderLogo from "../../RenderLogo";
import RenderContactInfo from "../../RenderContactInfo";
import RenderNav from "../../RenderNav";

type $Props = {
  classes: Object,
  onCloseDropdown: Function,
  compliance: Object,
  onToggleDropdown: Function,
  openDropdowns: Object,
  site: $Site,
};

class OfficeLogoRightNavBar extends Component<$Props> {
  handleClickOutside() {
    this.props.onCloseDropdown();
  }

  render() {
    const { classes, compliance } = this.props;
    return (
      <header
        className={classNames(classes.root, {
          [classes.stickyHeaderMargin]:
            compliance &&
            (compliance.stickyHeader ||
              compliance.stickyHeaderCustom ||
              compliance.stickyHeaderMobile),
          [classes.stickerHeaderMarginLarge]:
            compliance &&
            (compliance.stickyHeader || compliance.stickyHeaderMobile) &&
            compliance.stickyHeaderCustom,
        })}
      >
        <div className={classes.brandBar}>
          <div className={classes.logo}>
            <RenderLogo />
          </div>
          <div className={classes.agentInfo}>
            <RenderContactInfo />
          </div>
        </div>
        <hr className={classes.divider} />
        <div className={classes.navBarContainer}>
          <RenderNav />
        </div>
      </header>
    );
  }
}

const styles = (theme) => {
  const dividerColor = Color(theme.colors.primary["500"])
    .lighten(0.25)
    .toString();
  return {
    "@global": {
      "header a svg, header li svg": {
        verticalAlign: "top",
        marginTop: "-2px",
      },
    },
    root: {
      display: "flex",
      position: "relative",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      paddingTop: "0",
      backgroundColor: theme.colors.primary["500"],
      [theme.breakpoints(900)]: {
        justifyContent: "flex-start",
        zIndex: theme.zIndex["header"],
        "&:after": {
          display: "block",
          position: "absolute",
          content: "''",
          bottom: "-8px",
          left: "0",
          height: "8px",
          width: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.15)",
        },
      },
    },
    brandBar: {
      display: "none",
      [theme.breakpoints(900)]: {
        flex: "0 0 auto",
        display: "flex",
        position: "relative",
        flexFlow: "row nowrap",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        width: "100%",
        maxWidth: "970px",
        padding: "12px 0 12px",
      },
    },
    logo: {
      paddingRight: theme.spacing.unit,
      "& img": {
        maxWidth: "238px",
        maxHeight: "75px",
      },
    },
    agentInfo: {
      textAlign: "left",
      fontSize: "14px",
      lineHeight: "14px",
      color: theme.colors.primaryFontColor,
      "& a": {
        color: theme.colors.primaryFontColor,
      },
    },
    divider: {
      display: "none",
      [theme.breakpoints(900)]: {
        display: "block",
        margin: "0",
        padding: "0",
        width: "100%",
        height: "1px",
        border: "none",
        backgroundColor: dividerColor,
      },
    },
    navBarContainer: {
      width: "100%",
      [theme.breakpoints(900)]: {
        width: "auto",
      },
    },
    stickyHeaderMargin: {
      marginTop: theme.spacing.unit * 1.5,
      paddingTop: theme.spacing.unit * 1.5,
    },
    stickerHeaderMarginLarge: {
      marginTop: theme.spacing.unit * 3,
    },
  };
};

export default withGlobalContext(
  withStyles(styles)(enhanceWithClickOutside(OfficeLogoRightNavBar))
);
